import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function IND
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={42}
            labelBlock={'IND'}
            userConfiguration={true}
        />
    );
}
export default IND
